import { HttpLink } from '@apollo/client';
import { getBaseUrl } from './urls';

export const uriLink = new HttpLink({
  uri: getBaseUrl(),
  fetchOptions: {
    mode: 'cors',
  },
});
